export default __webpack_public_path__ + "static/media/Cancer.b7a72ece.png";